import get from 'lodash/get';

export const isLoggedInSelector = (state) => get(state, 'auth.isLoggedIn');
export const initPageFinishSelector = (state) =>
  get(state, 'auth.initPageFinish');

export const userEmailSelector = (state) => get(state, 'auth.userInfo.email');

export const userRoleSelector = (state) => get(state, 'auth.userInfo.role');
